export const CENTS_IN_COIN_RATE = 100;
export const KWD_RATE = 1000;
export const KCAL_RATE = 1000;
